module.exports = __webpack_public_path__ + "media/images/sindma/icon-constitucion-e75c4d78b82d44e69857c97e86b8710d.png";